const locale = {
  ui: {
    titleEyebrow: 'Un gioco di carte',
    titleSub:
      'I tuoi primi 90 giorni come Product Manager in una SaaS di medie dimensioni. ' +
      'Sopravvivi a 60 carte. Non sforare, non andare a zero.',
    titleCta: 'Inizia il giorno uno',
    titleBest: 'Miglior partita',
    titleEndings: 'Finali sbloccati',
    titleDays: 'giorni',
    creditsBy: 'thenew.pm — un gioco web di decision making di',
    creditsTagline: 'un gioco in cui sei il nuovo product manager',
    playHint: 'Scorri, tocca o usa ← / →',
    dayLabel: 'Giorno',
    endingDayLost: 'Giorno {day} — partita finita',
    endingDayWon: 'Giorno 90 — sei sopravvissuto',
    endingRestart: 'Nuovo PM, nuovo inizio',
    endingUnlocked: '{n} di {total} finali sbloccati',
  },
  stats: {
    e: { short: 'Ing.',    label: 'Fiducia ingegneria' },
    x: { short: 'Exec',    label: 'Fiducia esecutiva' },
    u: { short: 'Impatto', label: 'Impatto utente' },
    p: { short: 'Energia', label: 'Energia personale' },
  },
  roles: {
    engineer:  'Ingegneria',
    designer:  'Design',
    exec:      'Esecutivo',
    customer:  'Cliente',
    sales:     'Vendite',
    data:      'Dati',
    intern:    'Stagista',
    recruiter: 'Recruiting',
  },
  endings: {
    e0:   { title: 'Ignorato in silenzio',
            line: 'Ingegneria ha smesso di leggere i tuoi messaggi Slack al giorno 47.' },
    e100: { title: "Catturato dall'ingegneria",
            line: 'Sei PM solo di nome. I tech lead decidono ora cosa esce.' },
    x0:   { title: 'Licenziato',
            line: 'Il CEO aveva bisogno di un capro espiatorio per il trimestre fallito. Eri il più nuovo.' },
    x100: { title: 'Burattino degli exec',
            line: 'Consegni la slide OKR ogni venerdì. Niente altro è uscito da settimane.' },
    u0:   { title: 'Ha floppato',
            line: 'Il lancio è uscito. Nessuno ha notato.' },
    u100: { title: 'Spirale di scope',
            line: 'Tutte le feature sul muro sono state costruite. Nessuna è stata usata.' },
    p0:   { title: 'Burnout',
            line: 'Congedo medico al giorno 73. Il tuo laptop è ancora sulla scrivania.' },
    p100: { title: 'Spirale maniacale',
            line: "Doc strategia di 47 pagine. Martedì alle 3 di notte. Nessuno l'aveva chiesto." },
    w_cpo:       { title: 'CPO controvoglia',
                   line: "Il consiglio ti vuole nell'ufficio d'angolo. Non sei sicuro di volerlo." },
    w_shipped:   { title: 'Il PM che ha spedito',
                   line: 'Hai spedito la cosa. La gente la usa. Il team è ancora lì.' },
    w_hero:      { title: 'Eroe interno, mistero esterno',
                   line: 'Ingegneria ti adora. Marketing non ti ha mai sentito nominare.' },
    w_whisperer: { title: 'Sussurratore di roadmap',
                   line: 'Niente era perfetto. Niente bruciava. Il team si fida di te.' },
    w_survivor:  { title: 'Sei sopravvissuto 90 giorni',
                   line: 'Sei ancora qui. È la maggior parte.' },
  },
  cards: {
    c001: { title: 'Ingegnere Staff',
            prompt: "La migrazione auth slitterà di due settimane. Lo diciamo all'exec ora o aspettiamo la demo di venerdì?",
            left: 'Aspettare la demo', right: 'Segnalarlo oggi' },
    c002: { title: 'Designer Senior',
            prompt: 'Ingegneria ha rilasciato il nuovo dashboard senza il mio empty state ridisegnato. Ancora.',
            left: 'Spingere un hotfix', right: 'Metterlo in v2' },
    c003: { title: 'VP Product',
            prompt: 'Il consiglio vuole una slide "strategia AI" per giovedì. Non abbiamo strategia AI.',
            left: 'Buttarne giù una nel weekend', right: 'Dirle che è prematuro' },
    c004: { title: 'PM in TrialCo',
            prompt: '"Il vostro onboarding mi ha fatto piangere. Non in senso buono. Abbiamo churnato dal vostro concorrente."',
            left: 'Programmare una call', right: 'Inoltrare al supporto' },
    c005: { title: 'AE Enterprise',
            prompt: 'Un prospect strategico vuole SSO + audit log + SLA custom. 500k€ di ARR in gioco.',
            left: 'Declinare gentilmente', right: 'Costruirlo' },
    c006: { title: 'Data Scientist',
            prompt: "L'A/B test è inconcludente ma abbiamo superato la deadline. Spediamo la variante o la uccidiamo?",
            left: 'Spedire la variante', right: 'Ucciderla, rifare' },
    c007: { title: 'Stagista Product',
            prompt: '"Ho un\'idea per una feature. Praticamente è Slack ma per gatti."',
            left: 'Dirgli di concentrarsi', right: 'Ascoltarlo' },
    c008: { title: 'Recruiter Tech',
            prompt: 'Il candidato PM senior ha appena ricevuto una controproposta da Stripe. Abbiamo 24 ore.',
            left: "Pareggiare l'offerta", right: 'Lasciarlo andare' },
    c009: { title: 'Engineering Manager',
            prompt: "Metà del mio team pensa che la roadmap sia lavoro di performance. L'altra metà pensa sia il redesign.",
            left: 'Chiarire in un doc', right: "Dirgli di chiedere all'EM" },
    c010: { title: 'Product Designer',
            prompt: 'Marketing mi ha spinto un Figma con la loro idea per la pagina prezzi. Usa Comic Sans.',
            left: 'Rifarlo gentilmente', right: 'Inoltrare al brand' },
    c011: { title: 'CEO',
            prompt: '"Perché siamo ancora su OKR trimestrali? Anthropic spedisce ogni sei settimane."',
            left: 'Provare cicli di 6 settimane', right: 'Difendere il trimestre' },
    c012: { title: 'Procurement',
            prompt: 'Vogliono un report SOC 2 Type II entro fine mese o non rinnovano.',
            left: 'Promettere la data', right: 'Spingerlo al prossimo trimestre' },
    c013: { title: 'Account Executive',
            prompt: 'Il prospect in demo ha chiesto se abbiamo un\'integrazione HubSpot. Non l\'abbiamo. Posso dirgli "sulla roadmap"?',
            left: 'Sì, soft-promise', right: 'No, digli di no' },
    c014: { title: 'Senior Data Scientist',
            prompt: 'Penso che il funnel di attivazione stia doppio-contando i trial dello stesso dominio email.',
            left: 'Mettere la metrica in pausa', right: 'Sistemare in silenzio dopo' },
    c015: { title: 'Stagista Product',
            prompt: '"Posso assistere all\'offsite leadership? Prenderei solo appunti."',
            left: 'Portarlo', right: 'Magari la prossima' },
    c016: { title: 'Ingegnere Senior',
            prompt: 'Ci sono sei mesi di debito di design sulla pagina settings. Vuoi che lo sistemi nel mio 20%?',
            left: 'Sì per favore', right: 'Resta sulla roadmap' },
    c017: { title: 'UX Researcher',
            prompt: 'Ho cinque interviste utenti programmate. Vuoi unirti a una per vedere come va?',
            left: 'Bloccare 2h, andare', right: 'Manda solo le note' },
    c018: { title: 'CRO',
            prompt: 'Sales dice che chiuderemmo il 30% in più con un tier gratuito. Marketing dice che ucciderebbe la conversione.',
            left: 'Lanciare pilot tier gratuito', right: 'Tenere la linea' },
    c019: { title: 'Power User, ScaleCo',
            prompt: '"Il vostro export CSV tronca a 10k righe e ne servono 100k. Sta bloccando il nostro trimestre."',
            left: 'Alzare il limite', right: "Suggerire l'API" },
    c020: { title: 'AE Enterprise',
            prompt: 'Il loro CTO vuole una call di 30 min con "il PM che davvero gestisce la roadmap". Sei tu.',
            left: 'Prendere la call', right: 'Mandare un deck' },
    c021: { title: 'Frontend Lead',
            prompt: 'Migriamo il design system a v3 prima o dopo il lancio del redesign?',
            left: 'Prima (farlo bene)', right: 'Dopo (spedire prima)' },
    c022: { title: 'Data Scientist',
            prompt: 'Mixpanel dice che la retention sale del 4%. Amplitude dice che è piatta. Entrambi cablati da stagisti.',
            left: 'Auditare entrambi', right: 'Citare Mixpanel comunque' },
    c023: { title: 'VP Product',
            prompt: 'Puoi scrivere un one-pager su "product-led growth" per venerdì? Solo tre slide.',
            left: 'Farne uno vero', right: 'Riciclare il post di Lenny' },
    c024: { title: 'Stagista Product',
            prompt: "Ho notato che l'email di attivazione parte 14 minuti dopo la registrazione. Dovrebbe essere istantanea?",
            left: 'Farlo sistemare oggi', right: 'Aprire un ticket' },
    c025: { title: 'Recruiter Tech',
            prompt: 'Abbiamo headcount per un PM in più. Senior generalista o junior con esperienza growth?',
            left: 'Senior generalista', right: 'Junior orientato growth' },
    c026: { title: 'Designer Senior',
            prompt: 'Facciamo A/B test sulla nuova pagina prezzi o la spediamo direttamente?',
            left: 'A/B testarla', right: 'Spedirla diretta' },
    c027: { title: 'Ingegnere Staff',
            prompt: "Abbiamo un bug P1 in prod. L'ingegnere on-call è al matrimonio della sorella.",
            left: 'Pageare qualcun altro', right: 'Aspettare domani' },
    c028: { title: 'Team Sicurezza',
            prompt: '"La vostra storia di residenza dati non è chiara. Ci serve EU-only entro Q3 o non possiamo espanderci."',
            left: 'Impegnarsi al Q3', right: 'Spingerlo al Q4' },
    c029: { title: 'Account Executive',
            prompt: 'Ho detto a un prospect che avremmo costruito un sync Salesforce. Tranquillo, è piccolo.',
            left: 'Aggiungerlo alla roadmap', right: 'Fargli ritrattare' },
    c030: { title: 'Senior Data Scientist',
            prompt: 'La metrica North Star è "weekly active teams". Metà azienda traccia "daily active users".',
            left: "Forzare l'allineamento", right: 'Lasciarli derivare' },
    c031: { title: 'CFO',
            prompt: 'La fattura cloud è salita del 38% il mese scorso. Eri tu?',
            left: 'Investigare', right: 'Dare la colpa al vendor' },
    c032: { title: 'Product Designer',
            prompt: 'Voglio fare un design sprint in offsite. Tre giorni, zero meeting. Approvato?',
            left: 'Approvato', right: 'Magari il prossimo trimestre' },
    c033: { title: 'Engineering Manager',
            prompt: 'Il mio team vuole riscrivere il servizio billing in Rust. Stanno già prototipando.',
            left: 'Fermare il proto', right: 'Time-box una settimana' },
    c034: { title: 'Power User, ScaleCo',
            prompt: '"Avevate promesso il dark mode al QBR. Sono passati sei mesi."',
            left: 'Spedire dark mode ora', right: 'Scusarsi, riprogrammare' },
    c035: { title: 'AE Enterprise',
            prompt: 'Posso condividere la roadmap Notion col prospect? Continuano a chiedere.',
            left: 'Mandare un PDF ripulito', right: 'Mandare il link live' },
    c036: { title: 'Data Scientist',
            prompt: 'Ho costruito un modello di churn. Dice che il nostro più grande cliente parte tra 47 giorni.',
            left: 'Avvisare il loro CSM', right: 'Aspettare più segnale' },
    c037: { title: 'Stagista Product',
            prompt: '"Lo stage finisce tra due settimane. Possibilità di un\'offerta di rientro?"',
            left: 'Sì, mi batterò', right: 'Sincero: non sono sicuro' },
    c038: { title: 'Recruiter Tech',
            prompt: 'Il candidato ci ha ghostato dopo il take-home. Possiamo saltarlo per i senior?',
            left: 'Saltare per senior', right: 'Mantenere il livello' },
    c039: { title: 'CEO',
            prompt: "Voglio una demo all'All Hands di venerdì. Scegli qualcosa di figo.",
            left: 'Demo della feature AI mezza', right: 'Demo del fix billing noioso' },
    c040: { title: 'Ingegnere Senior',
            prompt: 'Il nostro staging non funziona da tre settimane. Nessuno se ne occupa.',
            left: 'Prenderne carico', right: 'È un problema SRE' },
    c041: { title: 'Designer Senior',
            prompt: 'Brand vuole rinfrescare il logo. Hanno un moodboard con sette serif sopra.',
            left: 'Lasciar decidere brand', right: 'Chiedere di aspettare' },
    c042: { title: 'Admin',
            prompt: '"L\'ultima release ha rotto silenziosamente il nostro setup SAML. Siamo tornati a email/password."',
            left: 'Rollback stanotte', right: 'Patch domattina' },
    c043: { title: 'Account Executive',
            prompt: 'Il CTO del prospect vuole vedere la nostra Jira board. "Per fiducia".',
            left: 'Condividere vista ripulita', right: 'No, è strano' },
    c044: { title: 'Senior Data Scientist',
            prompt: 'Looker Studio è giù. Due exec mi pingano. Posso solo mandare loro il CSV di ieri?',
            left: 'Mandare il CSV', right: 'Farli aspettare' },
    c045: { title: 'VP Product',
            prompt: "Ti metto a presentare all'offsite leadership. 20 minuti, senza slide.",
            left: 'Prendere lo slot', right: 'Declinare gentilmente' },
    c046: { title: 'Frontend Lead',
            prompt: 'Adottiamo React 19 ora o aspettiamo sei mesi che la polvere si posi?',
            left: 'Adottare ora', right: 'Aspettare sei mesi' },
    c047: { title: 'Stagista Product',
            prompt: '"Ho fatto shadow su tre call sales e un doc sulle obiezioni top. Possiamo spedire un fix?"',
            left: 'Portarlo allo standup', right: 'Tenere per il prossimo trimestre' },
    c048: { title: 'Recruiter Tech',
            prompt: 'Il candidato ha detto che vuole "lavorare su qualcosa che conta". Mando il deck dei valori?',
            left: 'Mandare il deck', right: 'Solo essere onesto' },
    c049: { title: 'Power User',
            prompt: '"Pagherei il doppio se mi lasciaste self-host. Non mi fido di nessuno con i miei dati, senza offesa."',
            left: 'Esplorare tier self-hosted', right: 'Declinare gentilmente' },
    c050: { title: 'CRO',
            prompt: "Possiamo anticipare l'aumento del rate-limit dell'API di due settimane? Sbloccherebbe tre deal.",
            left: 'Vedo cosa posso fare', right: 'No, il team è al limite' },
    c051: { title: 'Product Designer',
            prompt: 'Ho disegnato tre opzioni per la nuova nav. Una bold, una safe, una per ingegneri.',
            left: 'Spedire la bold', right: 'Spedire la safe' },
    c052: { title: 'Ingegnere Staff',
            prompt: 'Il debito tecnico segnalato in settimana 1 ora blocca il lancio. Postmortem time?',
            left: 'Sì, postmortem completo', right: 'No, andiamo avanti' },
    c053: { title: 'Data Scientist',
            prompt: 'Il nostro grafico DAU ha uno strano picco la domenica. Penso sia traffico bot dal docs site.',
            left: 'Toglierlo dalla metrica', right: 'Lasciarlo, è bello' },
    c054: { title: 'CEO',
            prompt: 'Stripe ha appena spedito quello che costruiamo da tre trimestri. Vuoi che li chiami?',
            left: 'Parlare con Patrick', right: 'No, abbiamo un angle' },
    c055: { title: 'Admin',
            prompt: '"Siamo sul trial da 90 giorni. Ci serve un\'estensione di 90 giorni."',
            left: 'Concederlo', right: 'Farli impegnare' },
    c056: { title: 'AE Enterprise',
            prompt: 'Procurement vuole uno sconto volume del 60%. Il CRO dice sì. Il modello dice no.',
            left: 'Tenere la linea', right: 'Accettare lo sconto' },
    c057: { title: 'Engineering Manager',
            prompt: 'Due dei miei migliori ingegneri vogliono passare al team piattaforma. Perderemmo velocità sulla roadmap.',
            left: 'Lasciarli partire', right: 'Bloccare il trasferimento' },
    c058: { title: 'UX Researcher',
            prompt: 'Otto utenti su dieci si sono bloccati sulla pagina settings nel test di usabilità. Vuoi i clip?',
            left: 'Mandare al leadership', right: 'Sistemare in silenzio' },
    c059: { title: 'Stagista Product',
            prompt: '"Ho notato che il link unsubscribe è rotto. Lo sistemo prima di andare."',
            left: 'Approvare il fix', right: 'Farlo fare a un FTE' },
    c060: { title: 'VP Product',
            prompt: 'Mi serve un 30-60-90 da te per il consiglio. Domani.',
            left: 'Tirare una nottata', right: 'Mandare quello del trimestre scorso' },
    c061: { title: 'Ingegnere Senior',
            prompt: 'Faccio il mio deck retro o uso il template del team?',
            left: 'Usare il template', right: 'Fai il tuo' },
    c062: { title: 'Designer Senior',
            prompt: 'Chiamiamo il design system "Atlas" ma legal dice che il marchio è di un altro.',
            left: 'Rinominarlo', right: 'Rischiare' },
    c063: { title: 'Senior Data Scientist',
            prompt: 'Marketing mi ha chiesto di fare un A/B test su una feature già 100% rilasciata.',
            left: 'Dirgli no', right: 'Imbroglio con un holdout' },
    c064: { title: 'Power User, ScaleCo',
            prompt: '"Il vostro concorrente offre di migrarci gratis. Convincimi a restare."',
            left: 'Avere una call', right: 'Mandare il deck' },
    c065: { title: 'Account Executive',
            prompt: 'Puoi assistere al QBR? Il cliente ha chiesto specificamente "qualcuno di tecnico".',
            left: 'Sì', right: "Manda l'EM" },
    c066: { title: 'CFO',
            prompt: 'Il burn del tuo team è 12% sopra il piano. Cosa si taglia?',
            left: 'Tagliare gli esperimenti AI', right: 'Tagliare il redesign' },
    c067: { title: 'Frontend Lead',
            prompt: "Abbiamo l'occasione di deprecare il supporto IE11. Risparmia 200ms su ogni pagina.",
            left: 'Deprecarlo', right: 'Aspettare un altro anno' },
    c068: { title: 'Stagista Product',
            prompt: '"Ultimo giorno. Ho fatto un deck di tutto quello che dovresti sistemare. Vuoi vederlo?"',
            left: 'Leggerlo bene', right: 'Sfogliarlo dopo' },
    c069: { title: 'Recruiter Tech',
            prompt: "Tre persone del team ingegneria vogliono referenziare amici. Abbassiamo l'asticella?",
            left: 'Mantenere il livello', right: 'Fast-track referrals' },
    c070: { title: 'CRO',
            prompt: 'Sales vuole "AI" nella copy prodotto su ogni pagina. Possiamo spedire un banner questa settimana?',
            left: 'Sì, mettiamolo', right: 'No, è rumore' },
    c071: { title: 'Ingegnere Staff',
            prompt: 'Sto pensando di andarmene. Non per soldi. La roadmap non mi entusiasma.',
            left: 'Avere un vero 1:1', right: 'Augurargli buona fortuna' },
    c072: { title: 'Product Designer',
            prompt: 'Marketing vuole usare gli screen v2 non rilasciati in un video di lancio. Pre-lancio.',
            left: 'No, non è pronto', right: 'Certo, perché no' },
    c073: { title: 'Data Scientist',
            prompt: "Ho ricostruito il funnel. L'attivazione vera è 11%, non 24%. Diciamo 24% agli investitori.",
            left: 'Dirlo stasera', right: 'Sederci sopra' },
    c074: { title: 'Procurement',
            prompt: '"Tocca il rinnovo. Vogliamo un 30% di sconto o andiamo al vendor X."',
            left: 'Pareggiare lo sconto', right: 'Lasciarli andare' },
    c075: { title: 'AE Enterprise',
            prompt: 'Puoi venire alla cena prospect venerdì? Hanno chiesto specificamente "prospettiva di prodotto".',
            left: 'Andare alla cena', right: 'Mandare un deck' },
    c076: { title: 'Engineering Manager',
            prompt: 'Il mio team ha fatto una retro blameless. Metà degli item riguardano i tuoi cambi roadmap.',
            left: 'Leggerlo, prendersene carico', right: 'Spingere sul framing' },
    c077: { title: 'CEO',
            prompt: 'Voglio che gestisca una nuova motion GTM. Self-serve. Decidi tu il team.',
            left: 'Prenderlo', right: 'Restare focalizzato' },
    c078: { title: 'Stagista di rientro',
            prompt: '"Torno dalla scuola. Ho un\'offerta di rientro Meta. Resto lì o vengo qui?"',
            left: 'Convincerlo', right: 'Pro e contro onesti' },
    c079: { title: 'Recruiter Tech',
            prompt: 'Abbiamo un PM senior perfetto in coda. Vuole full remote. Siamo "ibrido flessibile".',
            left: "Fare un'eccezione", right: 'Tenere la policy' },
    c080: { title: 'UX Researcher',
            prompt: 'Abbiamo budget per una grande iniziativa di research. Deep-dive onboarding o interviste churn?',
            left: 'Onboarding', right: 'Interviste churn' },
    c081: { title: 'Ingegnere Senior',
            prompt: 'Vorrei scrivere un blog post di ingegneria pubblico sulla nostra migrazione. Marketing ha detto no.',
            left: 'Scavalcare marketing', right: 'Stare con marketing' },
    c082: { title: 'Power User',
            prompt: '"Avete un\'alpha privata per la feature AI. Posso entrare? Vi do un testimonial."',
            left: 'Aggiungerli', right: 'Aspettare la GA' },
    c083: { title: 'VP Product',
            prompt: 'Me ne vado tra un mese. Vuoi il mio posto? Ti sosterrei, ma sei qui da 80 giorni.',
            left: 'Sì', right: 'Non ancora' },
    c084: { title: 'Senior Data Scientist',
            prompt: 'Voglio mettere su una review settimanale delle metriche prodotto. 30 min, ogni lunedì. Approvato?',
            left: 'Approvato', right: 'Abbiamo troppi meeting' },
    c085: { title: 'Account Executive',
            prompt: 'Posso registrare la tua demo e mandarla ai lead? Otteniamo 3x risposta quando i PM le fanno.',
            left: 'OK, registra', right: 'Non sono Marketing' },
    c086: { title: 'Frontend Lead',
            prompt: 'Dobbiamo deprecare la vecchia API. Due clienti sono lì. Entrambi minuscoli. Entrambi urleranno.',
            left: 'Deprecare come previsto', right: 'Rinviare di sei mesi' },
    c087: { title: 'Designer Senior',
            prompt: 'Voglio smettere di progettare in Figma e provare Penpot. Il team è diviso.',
            left: 'OK, prova', right: 'Restare su Figma' },
    c088: { title: 'CRO',
            prompt: "Voglio una roadmap pubblica. Sales l'amerebbe. Ingegneria la odierebbe.",
            left: 'Spedire roadmap pubblica', right: 'Tenerla interna' },
    c089: { title: 'CISO',
            prompt: '"Avete avuto un incidente minore il mese scorso. Vogliamo un postmortem scritto e un credito."',
            left: 'Mandare entrambi', right: 'Solo postmortem' },
    c090: { title: 'Stagista di rientro',
            prompt: '"Per la presentazione finale: l\'unica cosa che avresti voluto qualcuno ti dicesse il primo giorno?"',
            left: 'Essere onesto', right: 'Dire qualcosa di safe' },
    c091: { title: 'Frontend Lead',
            prompt: 'Ingegneria vuole migrare da Jira a Linear. Metà del team ha memoria muscolare nelle query Jira.',
            left: 'Approvare il passaggio', right: 'Restare su Jira' },
    c092: { title: 'Product Designer',
            prompt: "Ingegneria vuole Storybook per ogni componente. Tre settimane di lavoro, zero cambio visibile all'utente.",
            left: 'Trovare il tempo', right: 'Saltarlo per ora' },
    c093: { title: 'VP Product',
            prompt: 'Il mio deck per il consiglio è di 47 slide. Mi aiuti a tagliarlo prima di giovedì?',
            left: 'Tagliarlo a 12', right: "Aggiungere un'appendice" },
    c094: { title: 'Power User',
            prompt: '"Perché il vostro supporto è su Intercom e non Slack? Viviamo su Slack."',
            left: 'Aggiungere un canale Slack', right: 'Restare su Intercom' },
    c095: { title: 'AE Enterprise',
            prompt: 'Procurement vuole indennità illimitata nel contratto. Legal ha detto mai. Sales dice sì.',
            left: 'Cap a 1M$', right: 'Accettare illimitato' },
    c096: { title: 'Senior Data Scientist',
            prompt: 'Abbiamo 47 dashboard. Otto persone le usano. Vuoi che deprechi le 30 in fondo?',
            left: 'Deprecarle', right: 'Lasciarle stare' },
    c097: { title: 'Engineering Manager',
            prompt: 'Serve una rotazione on-call 24/7. Tre ingegneri rifiutano. Due dicono che si dimettono se forzati.',
            left: 'Su base volontaria', right: 'Renderlo obbligatorio' },
    c098: { title: 'Designer Senior',
            prompt: 'Brand vuole un doc di guidelines di 60 pagine. Ingegneria dice che nessuno lo leggerà.',
            left: 'Costruire il doc completo', right: 'Un one-pager basta' },
    c099: { title: 'Stagista di rientro',
            prompt: '"Voglio un mentor fuori dalla mia catena. Puoi trovarmene uno?"',
            left: 'Metterli in contatto', right: 'Suggerire che si arrangi' },
    c100: { title: 'CRO',
            prompt: 'Comprare il modulo analytics di CompetitorCo per 400k$ o costruirlo noi in due trimestri?',
            left: 'Comprarlo', right: 'Costruirlo noi' },
    c101: { title: 'Admin',
            prompt: 'NPS è sceso di 14 punti in un mese. I verbatim menzionano tutti "performance".',
            left: 'Pausare le feature per la perf', right: 'Spingere la perf al prossimo trimestre' },
    c102: { title: 'Recruiter Tech',
            prompt: 'Abbiamo benchmarkato la nostra fascia di comp PM. Siamo 18% sotto mercato. HR rifiuta di aggiustare.',
            left: 'Escalare al CEO', right: 'Conviverci' },
    c103: { title: 'Ingegnere Senior',
            prompt: 'Voglio dividere il monorepo. Sono otto mesi di lavoro. Il team è diviso.',
            left: 'Approvare la divisione', right: 'Tenere il monorepo' },
    c104: { title: 'Account Executive',
            prompt: 'Un rivenditore vuole white-labelarci in APAC. 30% di margine per loro, zero costo GTM per noi.',
            left: 'Firmare il deal', right: 'Restare diretti' },
    c105: { title: 'CEO',
            prompt: 'Voglio assumere un Head of AI. Il candidato viene da OpenAI e vuole 700k$ base.',
            left: "Fare l'offerta", right: 'Promuovere internamente' },
    c106: { title: 'Data Scientist',
            prompt: "L'audit GDPR ha trovato quattro cookie messi senza consenso. Legal li vuole via stasera.",
            left: 'Toglierli stasera', right: 'Programmare per lo sprint' },
    c107: { title: 'UX Researcher',
            prompt: "L'audit accessibilità ha trovato 38 fallimenti WCAG-AA. La maggior parte sono contrasto colore.",
            left: 'Bloccare la release', right: 'Spedire, aprire ticket backlog' },
    c108: { title: 'Power User, ScaleCo',
            prompt: '"La vostra status page diceva \'tutti i sistemi operativi\' durante un\'interruzione di 90 minuti. Notiamo."',
            left: 'Postmortem + scuse', right: 'Aggiornare lo SLA in silenzio' },
    c109: { title: 'AE Enterprise',
            prompt: 'Ho tre RFP per venerdì. Ognuno è 80 pagine di domande di compliance.',
            left: 'Aiutare con tutti e tre', right: 'Triare a uno' },
    c110: { title: 'CFO',
            prompt: 'Siamo a 18 mesi dal default. Licenziamenti o tagliare la prossima linea prodotto?',
            left: 'Tagliare la linea prodotto', right: 'Licenziamenti più piccoli' },
    f_custom_arr: { title: 'AE Enterprise',
            prompt: 'Tre settimane dopo. La feature custom da 500k€ è stata spedita. Ne vogliono altre due.',
            left: 'Tenere la linea', right: 'Costruire la prossima' },
    f_salesforce_sync: { title: 'Engineering Manager',
            prompt: 'Riguardo al sync Salesforce. Sono tre sprint di lavoro. Non abbiamo tre sprint.',
            left: "Tagliare un'altra feature", right: 'Dire a sales che non succederà' },
    f_indemnity: { title: 'AE Enterprise',
            prompt: "Tre settimane dopo. Il cliente ha attivato una richiesta di 3M$ sotto quell'indennità illimitata.",
            left: 'Pagare, imparare', right: 'Combatterlo in tribunale' },
    f_oncall: { title: 'Engineering Manager',
            prompt: "Due settimane dopo. L'on-call volontario ha avuto un volontario. Sta bruciandosi velocemente.",
            left: 'Pagare extra, doppia rotazione', right: 'Renderlo obbligatorio ora' },
    f_brand: { title: 'Designer Senior',
            prompt: 'Il doc brand di 60 pagine è finito. Ingegneria non ne usa nulla.',
            left: 'Imporre la conformità', right: 'Lasciarlo morire silenziosamente' },
    f_buy_build: { title: 'CRO',
            prompt: 'Il modulo CompetitorCo non si integra. La loro API non è documentata.',
            left: 'Pretendere un rimborso', right: 'Costruire un wrapper' },
    f_monorepo: { title: 'Ingegnere Senior',
            prompt: 'Tre mesi dopo. La divisione è a metà. La CI è rotta in entrambi i repo.',
            left: 'Fare rollback', right: 'Andare avanti' },
    f_channel: { title: 'Account Executive',
            prompt: 'Il rivenditore APAC sta tagliando i prezzi sui nostri deal diretti in ANZ. I clienti sono confusi.',
            left: 'Sottrarre ANZ', right: 'Tagliare il rivenditore' },
    f_ai_hire: { title: 'CEO',
            prompt: "L'Head of AI ha iniziato lunedì. Per venerdì vuole reindirizzare tutta la roadmap.",
            left: 'Ascoltarlo', right: 'Tenere la linea' },
    f_a11y: { title: 'UX Researcher',
            prompt: 'I 38 fix WCAG sono stati spediti. Sales dice che ora siamo eleggibili per un RFP settore pubblico.',
            left: "Inseguire l'RFP", right: 'Restare focus su SMB' },
    f_rfp: { title: 'AE Enterprise',
            prompt: 'Abbiamo vinto uno dei tre RFP. La consegna promessa è di 6 settimane. Ingegneria ha riso.',
            left: 'Rinegoziare lo scope', right: 'Promettere, poi tirare' },
    f_layoffs: { title: 'CFO',
            prompt: 'La linea prodotto che hai tagliato aveva tre clienti che pagavano 1.2M$ ARR. Vogliono rimborsi.',
            left: 'Rimborsare per intero', right: 'Offrire credito sul prodotto principale' },
    c111: { title: 'CTO',
            prompt: 'Voglio internalizzare tutto. Lasciamo AWS, lasciamo Stripe, costruiamo noi. Piano triennale.',
            left: 'Fare uno studio di fattibilità', right: 'Restare focus su quello che abbiamo' },
    c112: { title: 'Mobile Lead',
            prompt: 'Apple ha appena rifiutato la nostra app. Hanno segnalato la feature AI come "generazione di informazioni non verificate".',
            left: 'Risottoporre con disclaimer', right: 'Contestare il rifiuto' },
    c113: { title: 'VP Product',
            prompt: 'Voglio che la planning trimestrale duri cinque giorni, non due. OKR veri, non slide.',
            left: 'Adottarlo', right: 'Due giorni bastano' },
    c114: { title: 'Power User',
            prompt: '"Vogliamo essere design partner. Prodotto gratis, voi prendete il nostro logo e una citazione."',
            left: 'Iscriverli', right: 'Non ci serve un logo' },
    c115: { title: 'Ingegnere Sicurezza',
            prompt: "Il pen test ha trovato tre vulnerabilità RCE nell'API. Abbiamo 24 ore prima della divulgazione.",
            left: 'Tutti a patcharle stanotte', right: 'Negoziare la finestra di divulgazione' },
    c116: { title: 'Sales Engineer',
            prompt: "L'RFP del prospect richiede conformità GDPR + CCPA + LGPD + PIPEDA. Abbiamo GDPR.",
            left: 'Impegnarsi su tutte e quattro', right: 'Squalificarci' },
    c117: { title: 'Senior Data Scientist',
            prompt: 'Marketing vuole tracciare ogni evento di pagina in Mixpanel. Lo script di tracking pesa 240KB.',
            left: 'Tagliare agli eventi che contano', right: 'Tracciare tutto, riordinare poi' },
    c118: { title: 'Product Designer',
            prompt: 'Brand vuole un refresh completo. Logo, palette, tipografia. Sei mesi di lavoro.',
            left: 'Sostenere il progetto', right: 'Spingere indietro, focus prodotto' },
    c119: { title: 'CEO',
            prompt: "Voglio acquisire ToolCo. 2k clienti, 4M$ di ARR, nessuna crescita. Deal da 20M$.",
            left: 'Fare due diligence', right: 'Passare' },
    c120: { title: 'Recruiter Tech',
            prompt: 'Tre dei nostri PM sono stati pescati su LinkedIn questa settimana. Tre concorrenti diversi.',
            left: 'Indagare sulla cultura', right: 'Aspettare che passi' },
    c121: { title: 'CRO',
            prompt: 'Voglio ogni PM nelle call sales settimanali. Obbligatorio.',
            left: 'Provarlo', right: 'Bisettimanale, opt-in' },
    c122: { title: 'Ingegnere Senior',
            prompt: 'Il nostro sito docs ha 60% di bounce. Vuoi che dedichi uno sprint a riscriverlo?',
            left: 'Approvare lo sprint', right: 'Assumere un tech writer' },
    c123: { title: 'Procurement',
            prompt: '"Vogliamo il nostro logo FUORI dalla vostra homepage. Motivi di compliance."',
            left: 'Toglierlo stanotte', right: 'Spingere indietro, asset di sales' },
    c124: { title: 'Data Scientist',
            prompt: 'Voglio pubblicare un paper sul nostro modello di churn. Co-autore con accademici.',
            left: 'Approvare', right: 'Restare a testa bassa' },
    c125: { title: 'Stagista di rientro',
            prompt: '"Pubblico un post Medium sul mio stage. Vuoi rivederlo?"',
            left: 'Leggerlo bene', right: 'Fidarsi' },
    c126: { title: 'Chief of Staff',
            prompt: 'Il CEO vuole che tu gli rediga lo update al consiglio. Lo rivedrà domani.',
            left: 'Prenderlo', right: 'Declinare gentilmente' },
    c127: { title: 'UX Researcher',
            prompt: "Voglio intervistare i vostri peggiori clienti. Quelli che se ne sono andati arrabbiati.",
            left: 'Approvare il budget', right: 'Restare sugli utenti attuali' },
    c128: { title: 'Frontend Lead',
            prompt: 'Abbiamo un bundle JS da 4MB. Sales dice che il prodotto sembra "lento".',
            left: 'Fare uno sprint perf', right: 'Conviverci' },
    c129: { title: 'AE Enterprise',
            prompt: "Il cliente vuole un canale Slack privato condiviso con il team ingegneria.",
            left: 'Aprire il canale', right: 'Usare Intercom' },
    c130: { title: 'CFO',
            prompt: 'I nostri costi cloud schizzano al Black Friday. Reserved instances o autoscale?',
            left: 'Capacità riservata', right: 'Autoscale, ce lo mangiamo' },
    c131: { title: 'Ingegnere Staff',
            prompt: 'Ho riscritto il rate-limiter un sabato. La PR è aperta.',
            left: 'Revisionare e mergere', right: 'Non normalizzare il lavoro nel weekend' },
    c132: { title: 'Designer Senior',
            prompt: "Faccio il talk al WWDC sull'accessibilità. Permesso?",
            left: 'Approvato, pieno supporto', right: 'Forse un evento più piccolo' },
    c133: { title: 'Head of Talent',
            prompt: 'Abbiamo una offerta PM senior fuori. Vogliono rinegoziare il cliff di vesting.',
            left: 'Rinegoziare', right: 'Tenere la linea' },
    c134: { title: 'Engineering Manager',
            prompt: 'Voglio passare da review di performance trimestrali a mensili. La calibrazione si complica.',
            left: 'Provarlo', right: 'Restare trimestrali' },
    c135: { title: 'Legal',
            prompt: 'Un ingegnere con base in Russia ha toccato i nostri dati tramite il nostro subprocessor.',
            left: 'Indagare subito', right: 'Tagliare il subprocessor' },
    c136: { title: 'CTO in TenantCo',
            prompt: '"Vogliamo un deployment private cloud. Air-gapped. Paghiamo 5x."',
            left: "Costruire l'offerta", right: 'Passare, non è il nostro modello' },
    c137: { title: 'Account Executive',
            prompt: 'Ho fatto un deck dicendo che siamo "AI-first". Non lo siamo. Sales lo sta usando.',
            left: 'Correggerlo ora', right: 'Lasciarlo correre' },
    c138: { title: 'Product Designer',
            prompt: 'Ingegneria ha cancellato la mia config di design token in un refactor. Tre settimane perse.',
            left: 'Postmortem completo', right: 'Andare avanti, ripristinare da git' },
    c139: { title: 'CEO',
            prompt: 'Ho detto a Bloomberg che avremmo spedito la feature AI entro fine anno. Siamo a ottobre.',
            left: 'Smuovere cielo e terra', right: 'Fare marcia indietro' },
    c140: { title: 'VP Product',
            prompt: 'Mi prendo un sabbatico. Vuoi essere VP ad interim per tre mesi?',
            left: 'Sì', right: 'No' },
    f_in_house: { title: 'CTO',
            prompt: 'Sei mesi dopo. Siamo in ritardo sul build interno. La fattura AWS non è scesa.',
            left: 'Staccare la spina', right: 'Andare avanti' },
    f_apple_reject: { title: 'Mobile Lead',
            prompt: 'Apple ha accettato il reinvio. Google ha rifiutato lo stesso giorno.',
            left: 'Negoziare con Google', right: 'Spedire solo Apple' },
    f_design_partner: { title: 'Power User',
            prompt: '"Il design partner ora pretende un posto sulla roadmap."',
            left: 'Dargli il posto', right: 'Declinare gentilmente' },
    f_pen_test: { title: 'Ingegnere Sicurezza',
            prompt: 'Abbiamo patchato gli RCE. Il ricercatore ha pubblicato comunque.',
            left: 'Coordinare la divulgazione', right: 'Causa per violazione' },
    f_brand_refresh: { title: 'Product Designer',
            prompt: 'Il refresh brand è uscito. Twitter ha sfottuto il nuovo logo.',
            left: 'Difenderlo pubblicamente', right: 'Iterare a v1.5' },
    f_acquisition: { title: 'CEO',
            prompt: 'Il CEO di ToolCo vuole un posto in consiglio nel deal. I fondatori sono divisi.',
            left: 'Dargli il posto', right: 'Lasciare il deal' },
    f_perf_sprint: { title: 'Frontend Lead',
            prompt: 'Il bundle è a 1.2MB. Alcune feature si sono rotte.',
            left: 'Rollback delle feature rotte', right: 'Hotfix in avanti' },
    f_private_slack: { title: 'AE Enterprise',
            prompt: 'Lo Slack cliente-ingegneria ora ha altri sei PM in lettura.',
            left: 'Chiuderlo', right: 'Lasciarlo crescere' },
    f_data_breach: { title: 'Legal',
            prompt: "La forensic dice che i dati di un cliente sono stati consultati. Stanno chiedendo ora.",
            left: 'Divulgare stanotte', right: 'Aspettare legal' },
    f_acting_vp: { title: 'VP Product',
            prompt: "Karen è andata via. Il team sta testando i limiti.",
            left: "Mettere l'asticella alta", right: 'Conquistare la fiducia piano' },
  },
};

export default locale;
